<!-- 办公物品采购列表 -->
<template>
  <div class='page_content'>
    <el-drawer :close-on-press-escape="true" :visible.sync="showStatus" :with-header="false" append-to-bodycustom-class="drawer_box" direction="ltr" size="100%">
      <officeSuppliesPurchaseAction v-if="showStatus" ref="officeSuppliesPurchaseAction" @drawerCancel="drawerCancel" :actionData="actionData"></officeSuppliesPurchaseAction>
    </el-drawer>

    <div class="page_content_top">
      <v-button :buttonList="buttonList" @actionSet="actionSet" @getPageInfo="getPageInfo" @openFormDesign="openFormDesign"></v-button>
      <div class="page_content_top_line">
        <vSearch @searchData="searchData" :flagList="[]" @openSearchs="openSearch" :getRequestData=getRequestData v-if="pageShowData.jurHead" :searchList=pageShowData.jurHead.jurconfigform>
        </vSearch>
      </div>
    </div>
    <div class="page_content_center">
      <el-table v-if="pageShowData.jurTableVo" stripe :data="returnData.list" :height="tableHeight" :key="$store.state.tableNum" border style="width: 100%" highlight-current-row size="mini">
        <el-table-column label="选择操作" width="80">
          <template slot-scope="scope">
            <el-radio v-model="selectedDataIndex" :label="scope.$index" border size="mini">
              <i class="el-icon-thumb"></i>
            </el-radio>
          </template>
        </el-table-column>
        <!-- 采购主表格 -->
        <el-table-column align="center" v-if="tableValye.isShow == 1" v-for="(tableValye, tableKey) in pageShowData.jurTableVo.jurconfigtable" :key="tableKey" show-overflow-tooltip :prop="tableValye.entityField"
          :min-width="tableValye.fieldWeight" :label="tableValye.showField">
          <template slot="header">
            <div>
              <el-tooltip :disabled="isShowTooltip" :content="tableValye.showField" placement="top">
                <div class="long_title"><span :ref="tableValye.entityField">{{ tableValye.showField }}</span></div>
              </el-tooltip>
            </div>
          </template>
          <template slot-scope="scope">
            <el-tag size="mini" v-if="tableValye.entityField == 'isWms'">
              {{ scope.row.isWms == 0 ? '否' : '是' }}
            </el-tag>
            <el-tag size="mini" v-else-if="tableValye.entityField == 'purmState'">
              {{ $common.getIsGsp(tableValye.formatterContent, scope.row.purmState) }}</el-tag>
            <span v-else-if="tableValye.entityField == 'purmSdate'">
              <span v-if="scope.row[tableValye.entityField]">
                {{ $common.getLocalTime(scope.row[tableValye.entityField]) }}
              </span>
            </span>
            <span v-else-if="tableValye.isRift == 1">
              <a @click="toDetail(scope.row[tableValye.riftField])">{{ scope.row[tableValye.entityField] }}</a>
            </span>
            <span v-else>
              {{ scope.row[tableValye.entityField] }}
            </span>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <div class="page_content_bottom">
      <el-pagination background @size-change="setDataPageSize" @current-change="setDataPageNumber" :current-page="getRequestData.page" :page-sizes="[30, 50, 100, 500]" :page-size="30" layout="total, sizes, prev, pager, next, jumper"
        :total="returnData.total">
      </el-pagination>
    </div>
    <el-dialog :title="seTitle" v-if="DialogVisible" :visible.sync="DialogVisible" :width="seWidth">
      <SearchScheme ref="searchScheme" :id="seId" @TranData="changeInputModel" @getWidth="getSeWidth" :parentSearchData="parentSearchData" @sendTitle="getSearchName" />
    </el-dialog>
    <printPlan ref="printPlan"></printPlan>
    <!-- 自定义设计 -->
    <customDesign ref="customDesign"></customDesign>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import SearchScheme from "@/byComponents/SearchScheme.vue"
import officeSuppliesPurchaseAction from "@/components/officeSuppliesPurchaseAction.vue";

export default {
  //import引入的组件需要注入到对象中才能使用
  components: {
    SearchScheme,
    officeSuppliesPurchaseAction
  },
  data() {
    //这里存放数据
    return {
      tableHeight: 0,
      getRequestData: {
        page: 1,
        rows: 30,
        start: new Date().getTime() - 31 * 24 * 3600 * 1000, //获取上一个月
        end: new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1,	//当天最后时间,
        smId: '',
        smName: '',
        opmId: '',
        opmName: '',
        "creater": '',
        "ormId": '',
      },
      returnData: {
        pages: 0, // 总页数
        total: 0, // 总条数
        pageNum: 0, // 当前页数
        list: []
      },
      buttonList: [],
      pageShowData: [],
      formDataList: [],
      selectedDataIndex: 0,
      seId: "",
      seWidth: "",
      seTitle: "",
      sField: "",
      DialogVisible: false, //检索
      seType: '',
      isShowTooltip: false,
      showStatus: false,
      actionData: {},

    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {
    'getRequestData.opmName': { //查询头监听
      handler(newVal) {
        if (newVal == '') this.getRequestData.opmId = ''
      },
      deep: true
    },
    'getRequestData.smName': {
      handler(newVal) {
        if (newVal == '') this.getRequestData.smId = ''
      },
      deep: true
    },
  },
  //方法集合
  methods: {
    // 子组件触发
    drawerCancel() {
      this.showStatus = false
      this.getDataList()
    },
    // 点击穿透字段 传参单号
    toDetail(orderId) {
      if (orderId) {
        // 设置为true 打开穿透组件首页    
        var isPenetrate = true
        // 设置缓存 存入点击单号
        this.resetSetItem('penetrateOrderId', orderId);
        // 与父级跨域通信 传递isPenetrate参数
        window.parent.postMessage({ //向窗口发送MessageEvent消息
          cmd: 'returnFormJson',
          params: {
            isPenetrate
          } //参数
        }, '*');
      }

    },
    // 检索Id, 索引(表格中), 标识
    openSearch(sId, index, type, sField) {
      this.DialogVisible = true;
      this.seId = sId;
      this.sField = sField;
      this.seType = type;
      this.parentSearchData[type] = this.getRequestData[type];

    },
    //提取返回
    changeInputModel(val) {
      // console.log(val)

      if (val != "" || val != undefined) {
        this.DialogVisible = false;
        if (this.seType == 'opmId') {
          this.getRequestData.opmName = val.opmName
          this.getRequestData.opmId = val.opmId
        } else if (this.seType == 'smId') {
          this.getRequestData.smName = val.smName
          this.getRequestData.smId = val.smId
        } else {
          this.paramValue(val)
        }
      }
    },
    // 赋值字段
    paramValue(val) {
      let arr = this.sField.split(",");
      arr.forEach((item) => {
        this.getRequestData[item] = val[item];
      });
    },
    getSeWidth(e) {
      this.seWidth = e + "%";
    },
    getWidth(e) {
      this.exWidth = e + "%";
    },
    getSearchName(e) {
      this.seTitle = e;
    },

    // 动作集合
    actionSet(actionData) {
      console.log(actionData.actionType)
      switch (actionData.actionType) {
        case 0:
          this.showStatus = true
          this.actionData = {
            cate: 0,
            formData: this.formDataList,
            oldData: '',
            orderId: '',
            printSouce: '',
            printJurId: ''
          }
          break;
        case 1:
          var dataInfo = this.returnData.list[this.selectedDataIndex]
          if (!dataInfo) {
            this.$message({
              message: '请先选中要操作的数据',
              type: 'error'
            });
            return false
          }
          this.showStatus = true
          this.actionData = {
            cate: 1,
            formData: this.formDataList,
            oldData: dataInfo,
            orderId: "",
            printSouce: '',
            printJurId: ''
          }
          break;
        case 2:
          this.delDataAction()
          break;
        case 3:
          this.submitDataAction()
          break;

        case 8:
          this.showPrintPlan()
          break;
      }
    },
    openFormDesign() {
      let pathInfo = parent.getMenuInfo(this.$route.path)
      this.$refs['customDesign'].openBox(pathInfo.jurId, this.pageShowData, pathInfo.jurName)
    },
    showPrintPlan() {
      var dataInfo = this.returnData.list[this.selectedDataIndex]
      if (!dataInfo) {
        this.$message({
          message: '请先选中要操作的数据',
          type: 'error'
        });
        return false
      }
      // 调用全局方法 判断Websocket是否连接
      if (this.$printSocketApi.printExeMsg() != false) {
        // 选中的数据
        var info = this.returnData.list[this.selectedDataIndex]
        this.$refs.printPlan.openDia(info.purmId)
      } else {
        return
      }
    },
    // 删除数据
    delDataAction() {
      var dataInfo = this.returnData.list[this.selectedDataIndex]
      if (!dataInfo) {
        this.$message({
          message: '请先选中要操作的数据',
          type: 'error'
        });
        return false
      }

      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        var delData = {
          ids: [dataInfo.purmId]
        }
        let responseData = await this.$http.purchaseDelete(delData)
        if (responseData.status == 200) {
          this.$message({
            type: 'success',
            message: '删除成功!'
          });

          this.getDataList()
        } else {
          this.$message({
            message: responseData.message,
            type: 'error'
          });
        }

      }).catch(() => { });
    },
    // 提交审核
    async submitDataAction() {
      var dataInfo = this.returnData.list[this.selectedDataIndex]
      if (!dataInfo) {
        this.$message({
          message: '请先选中要操作的数据',
          type: 'error'
        });
        return false
      }

      // this.$confirm('确定要提交审核?', '提示', {
      //     confirmButtonText: '确定',
      //     cancelButtonText: '取消',
      //     type: 'warning'
      // }).then(async () => {
      var delData = {
        ids: [dataInfo.purmId]
      }
      let responseData = await this.$http.purchaseSubmit(delData)
      if (responseData.status == 200) {
        this.$message({
          type: 'success',
          message: '操作成功'
        });

        this.getDataList()
      } else {
        this.$message({
          message: responseData.message,
          type: 'error'
        });
      }

      // }).catch(() => {});
    },
    // 数据搜索
    searchData() {
      this.getRequestData.page = 1
      this.getDataList()
    },
    // 数据翻页
    setDataPageNumber(val) {
      this.getRequestData.page = val
      this.getDataList()
    },

    // 切换显示条数
    setDataPageSize(val) {
      this.getRequestData.page = 1
      this.getRequestData.rows = val
      this.getDataList()
    },

    // 获取数据列表
    async getDataList() {
      let responseData = await this.$http.getPurchaseQueryInit(this.getRequestData)
      if (responseData.status == 200) {
        this.returnData.list = responseData.result.list
        this.returnData.pages = responseData.result.pages
        this.returnData.total = responseData.result.total
        this.returnData.pageNum = responseData.result.pageNum
        this.selectedDataIndex = 0
      } else {
        this.$message({
          message: responseData.message,
          type: 'error'
        });
      }
    },

    // 获取数据列表
    async getPageInfo() {
      var pathId = parent.getMenuInfo(this.$route.path)
      let responseData = await this.$http.getJur({
        ids: [pathId.jurId]
      })
      if (responseData.status == 200) {
        this.pageShowData = responseData.result
        var obj = {}
        if (this.pageShowData.jurHead) {
          obj = this.$common.getSearchData(this.pageShowData.jurHead.jurconfigform, 'page', "rows", 30)
        } else {
          obj = this.$common.getSearch(this.getRequestData, 'start', 'end', 'page', 'rows', 30)
        }
        for (const key in obj) {
          this.$set(this.getRequestData, key, obj[key])
        }
        this.formDataList = this.pageShowData.jurFormVoList
        this.getDataList();
        this.getButtonList();
      } else {
        this.$message({
          message: responseData.message,
          type: 'error'
        });
      }
    },

    //获得状态
    getIsGsp(str, val) {
      try {
        if (str.indexOf('[') === -1) return val
        str && str.replace(/\\/g, '')
        let arr = JSON.parse(str)
        let len = arr.length
        let newStr = ''
        for (let i = 0; i < len; i++) {
          if (arr[i].key == val) {
            newStr = arr[i].value
            break;
          }
        }
        return newStr ? newStr : val
      } catch (ex) {
        return val
      }
    },

    // 获取按钮权限
    async getButtonList() {
      this.buttonList = await this.$common.getActionButton()
      
    },
},
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.getPageInfo()
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {

  },
  beforeCreate() { }, //生命周期 - 创建之前
  beforeMount() { }, //生命周期 - 挂载之前
  beforeUpdate() { }, //生命周期 - 更新之前
  updated() { this.tableHeight = this.$common.getTableHeight() }, //生命周期 - 更新之后
  beforeDestroy() { }, //生命周期 - 销毁之前
  destroyed() { }, //生命周期 - 销毁完成
  activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>

<style scoped>
.table_content_tag {
  margin-right: 1rem;
}

.el-tabs--border-card_new {
  height: 85vh;
  overflow-y: scroll;
}

.el-drawer {
  outline: none;
}
</style>